import React from 'react'
// Local type definition to avoid import issues
type BlockProps = {
  id?: string
  blockType?: string
  blockName?: string
  messages?: Array<{
    id?: string
    message: string
  }>
}
import { NewsTicker } from '@/components/NewsTicker'

export const NewsTickerBlock: React.FC<BlockProps> = ({ messages }) => {
  return (
    <NewsTicker
      messages={messages || []}
      backgroundColor="bg-black"
      textColor="text-white"
      height="h-8"
    />
  )
}
